import React from 'react';
import { render } from 'react-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as cp_action from 'actions/company';

import numeral from 'numeral';
import moment from 'moment';

const propTypes = {};

const defaultProps = {};

class StaffMealUseage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      divisionCode: this.props.divisionCode,
      page: 0,
      loadData: true,
      pageCnt: 20,
      totalCnt: 0,
      items: []
    };
    this.fetchMoreData = this.fetchMoreData.bind(this);
  }

  componentDidMount() {
    this.fetchMoreData();
  }

  fetchMoreData = async () => {
    console.log('fetchMoreData');
    const { cmAPI } = this.props;

    const { page } = this.state;
    let params = {
      page,
      pageCount: this.state.pageCnt
    };
    const reponse = await cmAPI.divisionBudgetSel(this.state.divisionCode, params);
    const { value } = reponse;
    if (value.data.contents.length > 0) {
      this.setState({
        totalCnt: value.data.totalCount || this.state.totalCnt,
        page: page + 1,
        items: this.state.items.concat(value.data.contents)
      });
    } else {
      this.setState({
        loadData: false
      });
    }
  };

  render() {
    return (
      <div>
        <div className="modal-useage-table">
          <div className="modal-list-header">
            <div className="col1">사용자</div>
            <div className="col2">식대구분</div>
            <div className="col3">식대사용</div>
            <div className="col4">사용일자</div>
          </div>
        </div>
        <InfiniteScroll
          className="modal-scroll"
          dataLength={this.state.items.length}
          next={this.fetchMoreData}
          hasMore={true}
          height={500}
          loader={
            this.state.items.length > 0 && this.state.loadData === true && <h4 className="show-loading">Loading...</h4>
          }
        >
          {this.state.items.length > 0 ? (
            this.state.items.map((i, index) =>
              i.usages.map((meal, idx) => {
                return (
                  <div key={`k${idx}`} className="modal-list-header">
                    <div className="col1 noline">{i.userName}</div>
                    <div className="col2 noline">{meal.policyName}</div>
                    <div className="col3 noline right-aligned">{numeral(meal.amount).format('0,0')} 원</div>
                    <div className="col4 noline">{moment(meal.usageDate).format('YYYY-MM-DD HH:mm:ss')}</div>
                  </div>
                );
              })
            )
          ) : (
            <div style={{ textAlign: 'center', padding: '20px' }}>예산 사용내역이 없습니다</div>
          )}
        </InfiniteScroll>
      </div>
    );
  }
}

StaffMealUseage.propTypes = propTypes;
StaffMealUseage.defaultProps = defaultProps;

StaffMealUseage = connect(
  (state) => ({
    staffList: state.commons.staff
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        divisionBudgetSel: cp_action.DivisionBudgetSel
      },
      dispatch
    )
  })
)(StaffMealUseage);

export default StaffMealUseage;
